export enum ProgramId {
	Us = 190603001,
	CanadaFlexPointsDenimSuedeTracking = 202000,
	CanadaFlexPointsFlexOffer = 202001092,
	TwoALoyalty = 2202001
}

export enum ProgramName {
	Us = "SSC US points",
	CanadaFlexPointsDenimSuedeTracking = "Flexpoints-TierTracking",
	CanadaFlexPointsFlexOffer = "Flexpoints-Redeem",
	TwoALoyalty = "2nd Ave points"
}